export const QUESTION_KIND = {
  ONLY_TEXT: "onlyText",
  TEST: "test",
  DROPDOWN: "dropdown",
  DROPDOWN2: "dropdown2",
  DND: "dnd",
  DND2: "dnd2",
  VIDEO: "video",
  IMAGE_QUIZ: "imageQuiz",
  INPUT: "input",
  MATCHING_PAIRS: "matchingPairs",
  FILLWORD: "fillword",
};

export function resolveQuestionKind(question) {
  if (!question || typeof question !== "object") {
    return QUESTION_KIND.ONLY_TEXT;
  }

  if (question.type === "text") {
    return QUESTION_KIND.ONLY_TEXT;
  }

  if (question.onlyText) {
    return QUESTION_KIND.ONLY_TEXT;
  }

  if (question.type === "dnd2") {
    return QUESTION_KIND.DND2;
  }

  if (question.type === "dnd") {
    return QUESTION_KIND.DND;
  }

  if (question.isGame) {
    return QUESTION_KIND.DND;
  }

  if (question.type === "video") {
    return QUESTION_KIND.VIDEO;
  }

  if (question.type === "imageQuiz") {
    return QUESTION_KIND.IMAGE_QUIZ;
  }

  if (question.type === "input") {
    return QUESTION_KIND.INPUT;
  }

  if (question.type === "matchingPairs") {
    return QUESTION_KIND.MATCHING_PAIRS;
  }

  if (question.type === "fillword") {
    return QUESTION_KIND.FILLWORD;
  }

  if (question.type === "dropdown") {
    return QUESTION_KIND.DROPDOWN;
  }

  if (question.type === "dropdown2") {
    return QUESTION_KIND.DROPDOWN2;
  }

  if (question.type === "interactive") {
    return QUESTION_KIND.DROPDOWN;
  }

  if (question.type === "test" || question.isTest) {
    return QUESTION_KIND.TEST;
  }

  if (Array.isArray(question.dropdownQuestionParts)) {
    return QUESTION_KIND.DROPDOWN;
  }

  if (Array.isArray(question.options) && question.correctAnswer) {
    return QUESTION_KIND.TEST;
  }

  return QUESTION_KIND.ONLY_TEXT;
}
